import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getPendingCharges } from '../../../api/rentals';

const usePendingCharges = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['pendingCharges'],
    queryFn: getPendingCharges,
    ...options,
  });
};

export default usePendingCharges;
